var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSvg3(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_14128",
    "data-name": "Group 14128",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 16.013,
    height: 16,
    viewBox: "0 0 16.013 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_5477",
    "data-name": "Rectangle 5477",
    width: 16.013,
    height: 16,
    fill: "#7dab3c"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_9589",
    "data-name": "Group 9589",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_29893",
    "data-name": "Path 29893",
    d: "M3.231,48.018a3.383,3.383,0,0,1,3.584,2.8,4.208,4.208,0,0,1-.363,2.433A12.425,12.425,0,0,1,4.2,56.611c-.118.133-.238.266-.368.389a.542.542,0,0,1-.774.008,12.009,12.009,0,0,1-2.78-4.145,3.66,3.66,0,0,1,.1-3.029,3.215,3.215,0,0,1,2.85-1.817m1.922,3.426A1.714,1.714,0,1,0,3.441,53.16a1.717,1.717,0,0,0,1.711-1.716",
    transform: "translate(0 -45.732)",
    fill: "#7dab3c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29894",
    "data-name": "Path 29894",
    d: "M8.176,12.587v-.258q0-5.8,0-11.6A1.431,1.431,0,0,1,8.184.493.571.571,0,0,1,9.317.551c0,.053,0,.107,0,.161q0,6.159,0,12.319c0,.49-.206.7-.69.7q-3.884,0-7.768,0a1,1,0,0,1-.3-.035.562.562,0,0,1-.383-.613.576.576,0,0,1,.534-.491c.059,0,.119,0,.179,0H8.176Z",
    transform: "translate(-0.166 -0.016)",
    fill: "#7dab3c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29895",
    "data-name": "Path 29895",
    d: "M217.435,12.571h.209q1.875,0,3.75,0a.57.57,0,0,1,.573.77.535.535,0,0,1-.52.369q-2.295.007-4.589,0a.566.566,0,0,1-.567-.57c0-.03,0-.06,0-.089q0-6.195,0-12.389A.927.927,0,0,1,216.324.4a.561.561,0,0,1,.605-.4.579.579,0,0,1,.5.523c.005.065,0,.131,0,.2q0,5.793,0,11.586Z",
    transform: "translate(-205.996 0)",
    fill: "#7dab3c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29896",
    "data-name": "Path 29896",
    d: "M8.175,312.073H15.55a.571.571,0,0,1,.591.758.556.556,0,0,1-.493.382,1.559,1.559,0,0,1-.178,0q-7.295,0-14.59,0a1.081,1.081,0,0,1-.316-.034.561.561,0,0,1-.386-.612.576.576,0,0,1,.532-.494c.059,0,.119,0,.179,0H8.175",
    transform: "translate(-0.165 -297.217)",
    fill: "#7dab3c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29897",
    "data-name": "Path 29897",
    d: "M61.374,108.612a.571.571,0,1,1-.574-.563.576.576,0,0,1,.574.563",
    transform: "translate(-57.365 -102.905)",
    fill: "#7dab3c"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSvg3);
export default __webpack_public_path__ + "static/media/svg3.efefb1e369c184d6a6842f55389f9a9a.svg";
export { ForwardRef as ReactComponent };